// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__0T+Z4","slide-down":"modal_slide-down__Dc7NO"};